import React from "react";

export default function Web_Vue() {
  return (
    <div>
      <h1>What is Vue.js</h1>
      <p>
        Route: <code>/web/vue</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
